// client/src/components/pedidos/PedidoRow.js
import React from 'react';
import { MoreVertical, Truck, CheckCircle } from 'lucide-react';
import { useTenantI18n } from '../../hooks/useAccounts';
import { formatCurrency as formatCurrencyUtil } from '../../utils/formatters';

const PedidoRow = ({ pedido, onOpenActions }) => {
    // ✅ ACHADO: fixo em BRL, sem ler configuracoesGerais.i18n da conta.
    const { currency, locale } = useTenantI18n();
    const formatCurrency = (value) => formatCurrencyUtil(value || 0, currency, locale);

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('pt-BR');
    };

    const getStatusBadge = (status) => {
        const statusConfig = {
            pendente: { color: 'bg-yellow-100 text-yellow-800', label: 'Pendente' },
            confirmado: { color: 'bg-blue-100 text-blue-800', label: 'Confirmado' },
            preparando: { color: 'bg-orange-100 text-orange-800', label: 'Preparando' },
            pronto_entrega: { color: 'bg-purple-100 text-purple-800', label: 'Pronto Entrega' },
            enviado: { color: 'bg-indigo-100 text-indigo-800', label: 'Enviado' },
            entregue: { color: 'bg-green-100 text-green-800', label: 'Entregue' },
            cancelado: { color: 'bg-red-100 text-red-800', label: 'Cancelado' },
            reembolsado: { color: 'bg-gray-100 text-gray-800', label: 'Reembolsado' }
        };

        const config = statusConfig[status] || { color: 'bg-gray-100 text-gray-800', label: status };
        
        return (
            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}>
                {config.label}
            </span>
        );
    };

    const getTipoBadge = (tipo) => {
        const tipoConfig = {
            produtos: { color: 'bg-green-100 text-green-800', label: 'Produtos' },
            servicos: { color: 'bg-blue-100 text-blue-800', label: 'Serviços' },
            recurso: { color: 'bg-orange-100 text-orange-800', label: 'Recurso' },
            locacao: { color: 'bg-amber-100 text-amber-800', label: 'Locação' },
            misto: { color: 'bg-purple-100 text-purple-800', label: 'Misto' }
        };

        const config = tipoConfig[tipo] || { color: 'bg-gray-100 text-gray-800', label: tipo };
        
        return (
            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}>
                {config.label}
            </span>
        );
    };

    const getEntregaBadge = (tipoEntrega) => {
        const config = tipoEntrega === 'entrega' 
            ? { color: 'bg-orange-100 text-orange-800', label: 'Entrega', icon: <Truck size={12} className="mr-1" /> }
            : { color: 'bg-cyan-100 text-cyan-800', label: 'Retirada', icon: <CheckCircle size={12} className="mr-1" /> };
        
        return (
            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}>
                {config.icon}
                {config.label}
            </span>
        );
    };

    return (
        <tr className="hover:bg-gray-50">
            <td className="font-mono font-medium text-gray-900">
                {pedido.numero}
            </td>
            
            <td>
                <div className="flex flex-col">
                    <span className="font-medium text-gray-900">
                        {pedido.cliente?.user?.name || 'Cliente não identificado'}
                    </span>
                    {pedido.cliente?.user?.email && (
                        <span className="text-sm text-gray-500">
                            {pedido.cliente.user.email}
                        </span>
                    )}
                </div>
            </td>
            
            <td className="text-sm text-gray-600">
                {formatDate(pedido.createdAt)}
            </td>
            
            <td className="text-center">
                <span className="font-medium">
                    {pedido.itens?.length || 0}
                </span>
            </td>
            
            <td className="font-semibold text-gray-900">
                {formatCurrency(pedido.total)}
            </td>
            
            <td>
                {getStatusBadge(pedido.status)}
            </td>
            
            <td>
                {getTipoBadge(pedido.tipo)}
            </td>
            
            <td>
                {getEntregaBadge(pedido.tipoEntrega)}
            </td>
            
            <td className="text-right">
                <div className="flex justify-end">
                    <button
                        onClick={() => onOpenActions(pedido)}
                        className="action-icon-button text-gray-600"
                        title="Ações"
                    >
                        <MoreVertical size={18} />
                    </button>
                </div>
            </td>
        </tr>
    );
};

export default PedidoRow;